import { Serializable } from '../../../../core/models/serializable';
import { RangeFilter } from '../../../../shared/models/range.model';

export class CustomerListFilterModel
  implements Serializable<CustomerListFilterModel>
{
  fromObject(object: any): CustomerListFilterModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    return {
      CustomerCredential: this.customerCredential,
      AccountManagerId: this.accountManagerId,
      HideZeroDebtCustomer: this.hideZeroDebtCustomer,
      CreateDate: this.createDate,
      TotalDebt: this.totalDebt,
    };
  }

  public customerCredential: string;
  public accountManagerId: number;
  public hideZeroDebtCustomer: boolean;
  public createDate: RangeFilter<Date>;
  public totalDebt: RangeFilter<number>;

  constructor() {
    this.createDate = new RangeFilter(null, null);
    this.totalDebt = new RangeFilter(null, null);
  }
}
